// Palace guards. The courtyard is closed to the public: pay the gate fee at the Palace Gate, or the guards
// warn you once, give you a few seconds to leave, then fine you once per trip. Real zone, real fine.
import { PalaceConfig as P } from '../config/capital.js'
import { record, debit, getTrip, isOnTrip } from './capitalTrip.js'
import { formatCoins } from '../ui/format.js'

const bag = () => { const t = getTrip(); return t ? (t.palace ??= { admitted: false, warnedAt: 0, fined: false }) : null }

export const isAdmitted = () => !!bag()?.admitted
export function admit() {
  const b = bag(); if (!b || b.admitted) return false
  b.admitted = true
  debit(P.admission, `Paid ${formatCoins(P.admission)} at the Palace Gate for admission to the courtyard`, 'guards')
  return true
}

export function checkTrespass(hx, hz, zones) {
  if (!isOnTrip()) return
  const b = bag()
  const inside = (zones ?? []).find((z) => hx >= z.minX && hx <= z.maxX && hz >= z.minZ && hz <= z.maxZ)
  if (!inside || b.admitted || b.fined) { if (!inside) b.warnedAt = 0; return }
  const now = Date.now()
  if (!b.warnedAt) {
    b.warnedAt = now
    record({ kind: 'info', source: 'guards', severity: 'smoke', text: `Palace guards spotted you in the ${inside.name} without leave. Leave within ${Math.round(P.warnMs / 1000)} s or be fined ${formatCoins(P.fine)}.` })
  } else if (now - b.warnedAt > P.warnMs) {
    b.fined = true
    debit(P.fine, `Palace guards fined you ${formatCoins(P.fine)} for trespassing in the ${inside.name}`, 'guards', 'banner')
  }
}
